import { Stack, Typography } from '@mui/material';
import { SimpleToggle } from 'Components/SimpleToggle';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { useContext, useEffect, useState } from 'react';
import { DateRange } from './DateRange';
import { YearRange } from './YearRange';
import { AdvancedSearchContext } from 'Context/PaymentDeductionContext/AdvancedSearchProvider';

export const DateFields = () => {
  const isDesktop = useIsDesktop();

  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.PaymentsDeductions
  ).search;
  const [dateRangeNotYear, setDateRangeNotYear] = useState<boolean>(true);
  const { advancedSearch } = useContext(AdvancedSearchContext);

  useEffect(() => {
    setDateRangeNotYear(!advancedSearch.dateRange.isYear);
  }, [advancedSearch]);

  return (
    <Stack
      direction='column'
      gap='16px'
      margin={isDesktop ? '0 0 48px 0' : '0 0 20px 0'}
    >
      <Typography variant={'body1'} tabIndex={0}>
        {dictionary.updateDateAndState}
      </Typography>
      <Stack
        direction='row'
        justifyContent='space-between'
        gap={isDesktop ? '48px' : '24px'}
        flexWrap={isDesktop ? 'nowrap' : 'wrap'}
      >
        <SimpleToggle
          option1={dictionary.dateRange}
          option2={dictionary.accordingToYear}
          setState={setDateRangeNotYear}
          isOption2={advancedSearch.dateRange.isYear}
        />
        <Stack
          direction={isDesktop ? 'row' : 'column'}
          width={isDesktop ? '425px' : '100%'}
          height={isDesktop ? '45px' : 'fit-content'}
          flexShrink={0}
          gap='16px'
        >
          {dateRangeNotYear ? <DateRange /> : <YearRange />}
        </Stack>
      </Stack>
    </Stack>
  );
};
